// src/lib/locale-url.js
const EXTERNAL = /^(https?:)?\/\//i;
const LOCALE_RE = /^\/(ko|en|ja|zh|th)(?=\/|$)/;

export function isExternal(href = "") {
  return EXTERNAL.test(href) || href.startsWith("tel:") || href.startsWith("mailto:");
}
export function norm(href = "/") {
  return href.startsWith("/") ? href : `/${href}`;
}
export function stripLeadingLocale(path = "/") {
  return (path || "/").replace(LOCALE_RE, "") || "/";
}

/** 언어별 공개 URL로 변환 (ko: 접두어 없음, en/ja/zh: /{lang}) */
export function withLocaleHref(href = "/", locale = "ko") {
  if (isExternal(href)) return href;
  let p = norm(href);
  p = stripLeadingLocale(p);
  if (locale && locale !== "ko") return `/${locale}${p === "/" ? "" : p}`;
  return p || "/";
}
